import "date-fns";
import React from "react";
import {
  Button,
  Checkbox,
  withStyles,
  FormControlLabel,
  FormGroup,
  Snackbar,
} from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";
import { ContactInputs } from "../../../utils/Data/dataTexts";
import { AddressInput } from "../../../components/FormInputs/FormInputs";
import { validateInput } from "../../../utils/Functions/functions";
import { withTranslation } from "react-i18next";
import i18n from "../../../utils/LanguageSelector/i18n";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const WhiteCheckbox = withStyles({
  root: {
    color: "white",
    "&$checked": {
      color: "white",
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

function ContactForm({ ...props }) {
  const [open, setOpen] = React.useState(false);
  const [error, setError] = React.useState("");
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };
  const checkEmail = () => {
    if (
      props.order.contact.email.length > 0 &&
      validateInput("email", props.order.contact.email).email === ""
    ) {
      return true;
    } else if (
      props.order.contact.email.length > 0 &&
      validateInput("email", props.order.contact.email).email !== ""
    ) {
      setError(validateInput("email", props.order.contact.email).email);
      return false;
    } else {
      setError(i18n.t("general.provideemailerr"));
      return false;
    }
  };
  const checkGdpr = () => {
    if (props.order.gdpr) {
      return true;
    } else {
      setError(i18n.t("general.acceptgdprerr"));
      return false;
    }
  };
  return (
    <>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        style={{ width: "100%" }}
      >
        <Alert onClose={handleClose} severity="error" className="AlertWidth">
          {error}
        </Alert>
      </Snackbar>
      <div className="StepContainer FormWidth">
        <div className="FormTitleContainer">
          <p className="FormQuestion">{i18n.t("contactform.label")}</p>
        </div>
        <div
          className="AddressContainer MarginHorizontal"
          style={{ background: "transparent" }}
        >
          {ContactInputs.map((input) => {
            return (
              <AddressInput
                label={input.label}
                key={input.id}
                id={input.id}
                style={{
                  flexBasis: window.innerWidth < 600 ? "100%" : input.width,
                }}
                value={props.order.contact[input.id]}
                onChange={(event) => {
                  props.handleContact(event);
                }}
              />
            );
          })}
          <FormGroup column>
            <FormControlLabel
              style={{ color: "white" }}
              control={
                <WhiteCheckbox
                  checked={props.order.gdpr}
                  id="gdpr"
                  onChange={(event) => props.handleCheck(event)}
                  name="gdpr"
                />
              }
              label={i18n.t("general.gdpragree")}
            />
            <FormControlLabel
              style={{ color: "white" }}
              control={
                <WhiteCheckbox
                  checked={props.order.marketing}
                  id="marketing"
                  onChange={(event) => props.handleCheck(event)}
                  name="marketing"
                />
              }
              label={i18n.t("general.newsletter")}
            />
          </FormGroup>
        </div>
      </div>
      <div className="NavigationContainer FormWidth">
        <Button
          onClick={() => {
            if (!props.order.delivery && props.order.destination === "") {
              props.handleBack();
            } else if (props.order.delivery) {
              props.handleBack();
            } else {
              props.handleBack(2);
            }
          }}
          className="TransparentWhite Medium"
        >
          {i18n.t("general.back")}
        </Button>
        <div>
          <Button
            onClick={() => {
              if (checkEmail() && checkGdpr()) {
                props.handleNext();
              } else setOpen(true);
            }}
            className="OldLace Medium"
          >
            {i18n.t("general.next")}
          </Button>
        </div>
      </div>
    </>
  );
}

export default withTranslation()(ContactForm);
